const reducer = (obj, str) => {
  const [key, value] = str.split('=');
  obj[key] = value;
  return obj;
};

export default (hash = window.location.hash) => {
  const params = hash.slice(1).split('&');
  return params.reduce(reducer, {});
};
